import { Navigate } from "react-router";
import { useAuthGuard } from "@/lib/hooks/useAuthGuard";
import { AuthContext } from "@/lib/contexts/AuthContext";
import { AppShell } from "@/components/layout/AppShell";
import { LoadingPage } from "./LoadingPage";

/**
 * Wraps all authenticated routes.
 * - Loading state → full-screen spinner
 * - Not authenticated → redirect to /login
 * - Authenticated → provides AuthContext so child components never
 *   independently re-resolve auth (avoids mid-session null races)
 */
export function ProtectedShell() {
  const user = useAuthGuard();

  if (user === undefined) return <LoadingPage />;
  if (user === null) return <Navigate to="/login" replace />;

  return (
    <AuthContext.Provider value={user}>
      <AppShell user={user} />
    </AuthContext.Provider>
  );
}
